/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  CustomInput,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Constants } from "../../Constants";
import { imageUpload } from "../../services/BannersServices";
import { fetchHome, putHomeModal } from "../../services/HomeServices";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import ViewInWeb from "../../components/Common/ViewInWeb";

function HomeModal() {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [imageText, setImageText] = useState("");

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchHome({
        token: "",
      });
      const { modal_title, modal_image, modal_image_text } =
        response.data.data.config;
      setTitle(modal_title || "");
      setImage(modal_image || "");
      setImageText(modal_image_text || "");
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      await putHomeModal({
        token: "",
        modalTitle: title,
        modalImage: image,
        modalImageText: imageText,
      });
      setLoading(false);
      toast(`Seccíon guardada con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const handleFiles = async (event: any) => {
    for (let file of event.target.files) {
      try {
        setLoading(true);
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "home",
        });
        setImage(response.data.data.image);
        setLoading(false);
      } catch (error: any) {
        console.log(error.response);
        setLoading(false);
        toast.error(`No se pudo subir la imagen, reintentar`, {
          position: toast.POSITION.BOTTOM_CENTER,
          pauseOnHover: false,
        });
      }
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content" id="HomeModal">
        <Container fluid={true}>
          <Breadcrumb title="Modal de inicio" breadcrumbItem="Modal de inicio" />
          <p className="text-muted">
            Ventana que aparece al entrar al inicio de la web (una vez por día).
          </p>
          <Row>
            <Col md={6}>
              <h5>Parte izquierda</h5>
              <FormGroup>
                <Label>Foto</Label>
                <div className="custom-file">
                  <CustomInput
                    id="modalImage"
                    type="file"
                    name="file"
                    accept="image/*"
                    className="custom-file-input"
                    onChange={handleFiles}
                  />
                </div>
              </FormGroup>
              {image ? (
                <div className="mb-3">
                  <img
                    src={`${Constants.BASE_URL}${image}`}
                    style={{ maxWidth: "100%", maxHeight: "400px" }}
                  />
                  <div>
                    <button
                      className="btn btn-link text-danger p-0 mt-1"
                      onClick={() => setImage("")}
                    >
                      Quitar foto (se usa la foto por defecto)
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-muted">
                  Sin foto cargada: se muestra la foto por defecto.
                </p>
              )}
              <FormGroup>
                <Label>Texto debajo de la foto</Label>
                <Input
                  type="textarea"
                  rows={3}
                  value={imageText}
                  onChange={(e) => setImageText(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <h5>Parte derecha</h5>
              <FormGroup>
                <Label>Título (arriba del formulario)</Label>
                <Input
                  type="textarea"
                  rows={3}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          <div className="row" style={{ marginTop: "1rem" }}>
            <div className="col-12 text-right">
              <ViewInWeb link="https://mariomendez.uy/" />
              <button
                className="btn btn-primary waves-effect waves-light"
                onClick={() => save()}
              >
                Guardar
              </button>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default HomeModal;
